/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../_chunks/dep-be6b014c.mjs';
import { _ as _slicedToArray } from '../_chunks/dep-1ec078b3.mjs';
import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { defineComponent, toRefs, ref, computed, createVNode, Fragment } from 'vue';
import { StarFilledIcon } from 'tdesign-icons-vue-next';
import useVModel from '../hooks/useVModel.mjs';
import props from './props.mjs';
import '../hooks/useConfig.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { Tooltip } from '../tooltip/index.mjs';
import { i as isArray_1 } from '../_chunks/dep-e9ff4ce8.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../_chunks/dep-558fadc3.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-398227bb.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-84053b94.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-c25d13e7.mjs';
import '../_chunks/dep-79d42d5d.mjs';
import '../_chunks/dep-979d7716.mjs';
import '../_chunks/dep-8b3be089.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-55311368.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-ad4331e8.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-16b9f817.mjs';
import '../_chunks/dep-e40749a5.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-437754aa.mjs';
import '../_chunks/dep-6dbd6c24.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../_chunks/dep-a861ee00.mjs';
import '../_chunks/dep-3514a375.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../hooks/useResizeObserver.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../config-provider/type.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Rate = defineComponent({
  name: "TRate",
  props: _objectSpread({}, props),
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var renderTNodeJSX = useTNodeJSX();
    var activeColor = isArray_1(props2.color) ? props2.color[0] : props2.color;
    var defaultColor = isArray_1(props2.color) ? props2.color[1] : "var(--td-bg-color-component)";
    var _toRefs = toRefs(props2),
      inputValue = _toRefs.value,
      modelValue = _toRefs.modelValue;
    var _useVModel = useVModel(inputValue, modelValue, props2.defaultValue, props2.onChange),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      starValue = _useVModel2[0],
      setStarValue = _useVModel2[1];
    var hoverValue = ref(void 0);
    var root = ref();
    var displayValue = computed(function () {
      return Number(hoverValue.value || starValue.value);
    });
    var displayTexts = computed(function () {
      return props2.texts.length === 0 ? ["\u6781\u5DEE", "\u5931\u671B", "\u4E00\u822C", "\u6EE1\u610F", "\u60CA\u559C"] : props2.texts;
    });
    var displayText = computed(function () {
      return displayTexts.value[Math.ceil(displayValue.value - 1)];
    });
    var RateIcon = function RateIcon(iconProps) {
      if (slots.icon !== void 0) {
        return renderTNodeJSX("icon", {
          params: iconProps
        });
      }
      return createVNode(StarFilledIcon, iconProps, null);
    };
    var getStarValue = function getStarValue(event, index) {
      if (props2.allowHalf) {
        var _root$value$getBoundi = root.value.getBoundingClientRect(),
          left = _root$value$getBoundi.left;
        var firstStar = root.value.firstChild.nextSibling;
        var _firstStar$getBoundin = firstStar.getBoundingClientRect(),
          width = _firstStar$getBoundin.width;
        var clientX = event.clientX;
        var starMiddle = width * (index - 0.5) + props2.gap * (index - 1);
        if (clientX - left >= starMiddle) return index;
        if (clientX - left < starMiddle) return index - 0.5;
      }
      return index;
    };
    var mouseEnterHandler = function mouseEnterHandler(event, index) {
      if (props2.disabled) return;
      hoverValue.value = getStarValue(event, index);
    };
    var mouseLeaveHandler = function mouseLeaveHandler() {
      if (props2.disabled) return;
      hoverValue.value = void 0;
    };
    var clickHandler = function clickHandler(event, index) {
      if (props2.disabled) return;
      setStarValue(getStarValue(event, index));
    };
    var getStarCls = function getStarCls(index) {
      if (props2.allowHalf && index + 0.5 === displayValue.value) return "".concat(classPrefix.value, "-rate__item--half");
      if (index >= displayValue.value) return "";
      if (index < displayValue.value) return "".concat(classPrefix.value, "-rate__item--full");
    };
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    return function () {
      return createVNode("div", {
        "class": "".concat(classPrefix.value, "-rate"),
        "onMouseleave": mouseLeaveHandler
      }, [createVNode("ul", {
        "class": "".concat(classPrefix.value, "-rate__list"),
        "style": {
          gap: "".concat(props2.gap, "px")
        },
        "ref": root
      }, [_toConsumableArray(Array(Number(props2.count))).map(function (_, index) {
        return createVNode("li", {
          "key": index,
          "class": ["".concat(classPrefix.value, "-rate__item"), getStarCls(index)],
          "onClick": function onClick(event) {
            return clickHandler(event, index + 1);
          },
          "onMousemove": function onMousemove(event) {
            return mouseEnterHandler(event, index + 1);
          }
        }, [props2.showText ? createVNode(Tooltip, {
          "key": index,
          "content": displayText.value
        }, {
          "default": function _default() {
            return [createVNode("div", {
              "class": "".concat(classPrefix.value, "-rate__star-top")
            }, [createVNode(RateIcon, {
              "size": props2.size,
              "color": activeColor
            }, null)]), createVNode("div", {
              "class": "".concat(classPrefix.value, "-rate__star-bottom")
            }, [createVNode(RateIcon, {
              "size": props2.size,
              "color": defaultColor
            }, null)])];
          }
        }) : createVNode(Fragment, null, [createVNode("div", {
          "class": "".concat(classPrefix.value, "-rate__star-top")
        }, [createVNode(RateIcon, {
          "size": props2.size,
          "color": activeColor
        }, null)]), createVNode("div", {
          "class": "".concat(classPrefix.value, "-rate__star-bottom")
        }, [createVNode(RateIcon, {
          "size": props2.size,
          "color": defaultColor
        }, null)])])]);
      })]), props2.showText && createVNode("div", {
        "className": "".concat(classPrefix.value, "-rate__text")
      }, [displayText.value])]);
    };
  }
});

export { _Rate as default };
//# sourceMappingURL=rate.mjs.map
